<template>
    <form id="f-reg-webinar" @submit.prevent="handleRegisterForm()" novalidate>
        <div class="form-section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <a href="/logowanie" class="back-login"><i class="bi bi-chevron-left"></i> wróć do logowania</a>
                    </div>
                </div>
                <div class="row form-heading">
                    <div class="col-lg-12">
                        <h2>Zarejestruj się</h2>
                        <p>Posiadasz już konto? <a href="/logowanie">Zaloguj się</a></p>
                        <p><br>Wydarzenie jest płatne<br>Płatności można dokonać po potwierdzeniu konta</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <form-input label="Imię" v-model="name" :modelValue="name" type="text" name="name" :errorMessages="errorMessages"></form-input>
                    </div>
                    <div class="col-md-6">
                        <form-input label="Nazwisko" v-model="last_name" :modelValue="last_name" type="text" name="last_name" :errorMessages="errorMessages"></form-input>
                    </div>
                    <div class="col-md-6">
                        <form-input label="Adres e-mail" v-model="email" :modelValue="email" :register="true" type="email" name="email" :errorMessages="errorMessages"></form-input>
                    </div>
                    <div class="col-md-6">
                        <form-input label="Numer telefonu" v-model="phone" :modelValue="phone" type="phone" name="phone" :errorMessages="errorMessages"></form-input>
                    </div>

                    <input type="hidden" v-model="profession" :modelValue="profession" name="profession" value="profession_id">

                    <div class="col-md-6" v-if="profession_id != 3 && profession_id != 6 && profession_id != 4 && profession != 8">
                        <form-input label="Podaj numer prawa wykonywania zawodu" v-model="pwz_number" :modelValue="pwz_number" type="text" name="pwz_number" :errorMessages="errorMessages"></form-input>
                    </div>

                    <div class="col-md-6" v-if="profession_id != 4 && profession_id != 6">
                        <form-input label="Miejsce pracy" v-model="work_place" :modelValue="work_place" type="text" name="work_place" :errorMessages="errorMessages"></form-input>
                    </div>

                    <div class="col-md-6" v-if="profession_id == 1">
                        <form-input label="Specjalizacja" v-model="specialization" :modelValue="specialization" type="text" name="specialization" :errorMessages="errorMessages"></form-input>
                    </div>

                    <div class="col-md-6" v-if="profession_id == 4">
                        <form-input label="Uniwersytet" v-model="university" :modelValue="university" type="text" name="university" :errorMessages="errorMessages"></form-input>
                    </div>

                    <div class="col-md-6" v-if="profession_id == 4">
                        <form-input label="Podaj numer legitymacji studenckej" v-model="card" :modelValue="card" type="text" name="card" :errorMessages="errorMessages"></form-input>
                    </div>

                    <div class="col-md-6" v-if="profession_id == 6">
                        <form-input label="Podaj firmę, której jesteś przedstawicielem" :modelValue="company_represented" type="text" name="company_represented" v-model="company_represented" :error-messages="errorMessages"></form-input>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <form-input label="Hasło" v-model="password" :modelValue="password" type="password" name="password" :errorMessages="errorMessages"></form-input>
                    </div>
                    <div class="col-md-6">
                        <form-input label="Powtórz hasło" v-model="password_confirm" :modelValue="password_confirm" type="password" name="password_confirm" :errorMessages="errorMessages"></form-input>
                    </div>
                </div>

                <div class="row form-group-heading">
                    <div class="col-lg-12">
                        <h2>Dane do faktury</h2>
                    </div>
                </div>
                <form-user-type v-model="user_type" name="user_type" :modelValue="user_type" :errorMessages="errorMessages"></form-user-type>
                <div class="form" v-if="user_type">
                    <div class="row">
                        <div class="col-md-6">
                            <form-input :disactive="user_type === 'person'" :modelValue="company_name" size="form-group--small" label="Nazwa firmy" v-model="company_name" type="text" name="company_name" :errorMessages="errorMessages"></form-input>
                        </div>
                        <div class="col-md-6">
                            <form-input :disactive="user_type === 'person'" :modelValue="nip" size="form-group--small" label="NIP" v-model="nip" type="text" name="nip" v-mask="[/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]" :errorMessages="errorMessages"></form-input>
                        </div>
                        <div class="col-md-6">
                            <form-input  size="form-group--small" label="Ulica" v-model="street" :modelValue="street" type="text" name="street" :errorMessages="errorMessages"></form-input>
                        </div>
                        <div class="col-md-3">
                            <form-input size="form-group--small" label="Numer domu" v-model="house_number" :modelValue="house_number" type="text" name="house_number" :errorMessages="errorMessages"></form-input>
                        </div>
                        <div class="col-md-3">
                            <form-input size="form-group--small" label="Numer mieszkania" v-model="flat_number" :modelValue="flat_number" type="text" name="flat_number" :errorMessages="errorMessages"></form-input>
                        </div>
                        <div class="col-md-6">
                            <form-input size="form-group--small" label="Kod pocztowy" v-model="post_code" :modelValue="post_code" type="text" name="post_code" :errorMessages="errorMessages" :placeholder="'XX-XXX'"></form-input>
                        </div>
                        <div class="col-md-6">
                            <form-input size="form-group--small" label="Miasto" v-model="city" :modelValue="city" type="text" name="city" :errorMessages="errorMessages"></form-input>
                        </div>
                    </div>
                </div>

                <div class="mt-3">
                    <form-user-agreement-input :require="1" :label="privacy_agreement_label" :modelValue="privacy_agreeement" v-model="privacy_agreeement" name="privacy_agreeement" :error-messages="errorMessages"></form-user-agreement-input>
                    <form-user-agreement-input :require="0" :label="marketing_agreement_label" :modelValue="marketing_agreeement" v-model="marketing_agreeement" name="marketing_agreeement" :error-messages="errorMessages"></form-user-agreement-input>
                </div>

                <div class="alert alert-danger" v-if="professionError">
                    <p>
                        Wystąpił błąd przetwarzania formularza:
                    </p>

                    <ul>
                        <li v-html="errorMessages.profession[0]"></li>
                    </ul>

                </div>

                <div class="form-bottom">
                    <div class="container">
                        <div class="form-bottom__button">
                            <button>ZAREJESTRUJ SIĘ<br></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    import FormInput from "./formInput";
    import Spinner from 'vue-simple-spinner';
    import FormUserType from "./formUserType";
    import FormAgreementInput from "./formAgreementInput";
    import FormUserAgreementInput from "./formUserAgreementInput";

    export default {
        props: ['profession_id','agreement_inputs', 'privacy_agreement_content', 'marketing_agreement_content'],

        components: {
            FormUserType,
            FormAgreementInput,
            FormInput,
            FormUserAgreementInput,
            Spinner
        },
        data() {
            return {
                email: null,
                password: null,
                password_confirm: null,
                name: null,
                last_name: null,
                profession: this.profession_id,
                specialization: null,
                pwz_number: null,
                company_name: null,
                street: null,
                card: null,
                university: null,
                user_type: 'person',
                house_number: null,
                flat_number: null,
                city: null,
                post_code: null,
                nip: null,
                work_place: null,
                errorMessages: null,
                successStatus: null,
                processing: false,
                company_represented: null,
                phone: null,
                professionError: false,
                agreements: [],
                specialAgreementInputs: [],
                privacy_agreeement: 0,
                marketing_agreeement: 0,
                privacy_agreement_label: this.privacy_agreement_content,
                marketing_agreement_label: this.marketing_agreement_content,
            }
        },

        methods: {
            handleRegisterForm() {
                axios.post('/api/register', {
                    email: this.email,
                    password: this.password,
                    password_confirm: this.password_confirm,
                    name: this.name,
                    last_name: this.last_name,
                    profession: this.profession,
                    specialization: this.specialization,
                    pwz_number: this.pwz_number,
                    company_name: this.company_name,
                    street: this.street,
                    card: this.card,
                    university: this.university,
                    house_number: this.house_number,
                    flat_number: this.flat_number,
                    city: this.city,
                    post_code: this.post_code,
                    nip: this.nip,
                    work_place: this.work_place,
                    user_type: this.user_type,
                    company_represented: this.company_represented,
                    phone: this.phone,
                    privacy_agreeement: this.privacy_agreeement,
                    marketing_agreeement: this.marketing_agreeement
                })
                .then(response => {
                    this.processing = true;
                })
                .then(response => {
                    this.processing = false;
                    window.location.href = '/podziekowanie';
                })
                .catch(error => {
                    this.errorMessages = error.response.data.errors;
                    if (error.response.data.errors.profession){
                        this.professionError = true;
                    }
                }).then(error => {
                    window.scrollTo(0, document.querySelector('.error').offsetParent.offsetTop);
                });
            },
        }

    }
</script>
